import React, {FC, useMemo} from 'react';
import {ColDef} from 'ag-grid-community';
import {PaymentStatisticResponse} from '../../shared/types/report';
import HLPageTable, {HLPageTableFilterConfig} from '../../shared/components/table/HLPageTable';
import {getPaymentStatisticsFetch} from "../../app/axios/reportFetches";
import {useTeachersCache} from "../../shared/hooks/useTeachersCache";
import {useAppSelector} from "../../shared/hooks/useAppSelector";
import {TeacherRole} from "../../shared/types/teacher";
import {getDateRange} from "../../shared/utils/dateUtils";

const defaultColDef: ColDef<PaymentStatisticResponse> = {
    sortable: false,
    filter: false,
    resizable: true,
    minWidth: 100,
};

const PaymentStatisticTable: FC = () => {
    const {getTeacherOptions} = useTeachersCache();
    const currentTeacher = useAppSelector(state => state.auth.currentTeacher)
    const defaultDates = useMemo(() => getDateRange(14, 'days'), []);

    const columnDefs: ColDef<PaymentStatisticResponse>[] = [
        {
            field: 'agreementName',
            headerName: 'Имя договора',
            flex: 2,
        },
        {
            field: 'lessonsConducted',
            headerName: 'Проведено уроков',
            flex: 1,
            type: 'number',
        },
        {
            field: 'teacherSalary',
            headerName: 'Зарплата учителя',
            flex: 1,
            valueFormatter: params => params.value ? `${params.value} ₽` : `0 ₽`,
            type: 'number',
        }
    ];

    const searchFiltersConfig: HLPageTableFilterConfig<any>[] = [
        {
            fieldName: 'startDate',
            label: 'Дата начала',
            operator: '=',
            type: 'date',
            required: true,
            defaultValue: defaultDates.startDate
        },
        {
            fieldName: 'endDate',
            label: 'Дата окончания',
            operator: '=',
            type: 'date',
            required: true,
            defaultValue: defaultDates.endDate
        },
    ];

    if (currentTeacher?.role === TeacherRole.ADMIN) {
        searchFiltersConfig.unshift({
            fieldName: 'teacherId',
            label: 'Учитель',
            operator: '=',
            type: 'select',
            options: getTeacherOptions(),
        })

        columnDefs.splice(2, 0, {
            field: 'income',
            headerName: 'Доход',
            flex: 1,
            valueFormatter: params => params.value ? `${params.value} ₽` : `0 ₽`,
            type: 'number',
        })
        columnDefs.push({
            field: 'netProfit',
            headerName: 'Чистая прибыль',
            flex: 1,
            valueGetter: (params: any) => (params.data?.income ?? 0) - (params.data?.teacherSalary ?? 0),
            valueFormatter: params => params.value ? `${params.value} ₽` : `0 ₽`,
            type: 'number',
        })
    }


    return (
        <HLPageTable
            title="Статистика платежей"
            columns={columnDefs}
            defaultColDef={defaultColDef}
            filterConfig={searchFiltersConfig}
            actionButtons={[]}
            rowModelType={'clientSide'}
            fetchData={getPaymentStatisticsFetch}
            height={600}
            showStatisticsButton={true}
        />
    );
}

export default PaymentStatisticTable;